import http from '@/utils/js/http.js';

// 获取微信JSSDK参数
const getJSSDKParams = params =>
    http.post({
        url: '/wx/share/getSignature',
        data: params
    });

//获取openId
const getOpenId = params =>
    http.get({
        url: '/wx/api/customerwx/getOpenId',
        data: params
    });

// 获取微信用户信息
const getWechatUser = params =>
    http.get({
        url: '/proposal/api/wechat/getWechatUser',
        data: params
    });
//ocr识别
const ocrRecognition = params =>
    http.post({
        url: '/wx/auxiliary/ocrRecognition',
        data: params
    });
//短信分享
const Sharing = params =>
    http.post({
        url: '/wx/auxiliary/text/Sharing',
        data: params
    });
//人脸识别参数带出接口
const faceData = params =>
    http.post({
        url: '/wx/face/faceData',
        data: params
    });
//客户号人脸识别参数带出接口
const customerFace = params =>
    http.post({
        url: '/wx/face/customerFace',
        data: params
    });
//微信H5人脸识别获取链接
const getURL = params =>
    http.post({
        url: '/wx/face/wxh5/getURL',
        data: params
    });
//微信H5人脸识别获取结果
const getResult = params =>
    http.post({
        url: '/wx/face/wxh5/getResult',
        data: params
    });
//获取我的推荐海报图片
const create = params =>
    http.post({
        url: '/wx/api/poster/create',
        data: params
    });

export {
    getWechatUser,
    getJSSDKParams,
    getOpenId,
    ocrRecognition,
    Sharing,
    faceData,
    customerFace,
    getURL,
    getResult,
    create
};
